module.exports = __webpack_public_path__ + "img/7.80eb3a3d.png";